import { useIntl } from "react-intl";

import { useLocalizedHref } from "@/libraries/web-framework";

const SessionDurationManagement = () => {
    const intl = useIntl();

    const AtlassianLink = `https://www.atlassian.com${useLocalizedHref("/")}`;

    const messages = {
        header: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.SessionDurationManagement.header",
            defaultMessage: "Session duration management (desktop)"
        }),
        body: intl.formatMessage(
            {
                id: "JiraServiceManagementPricingPage.features.SessionDurationManagement.body",
                defaultMessage:
                    "Session duration management allows an organization admin to set a session timeout value different from the default policy of 30 days. This means admins can control how long a team member can stay signed in without interacting with <atlassian>Atlassian.com</atlassian>."
            },
            {
                atlassian: (chunk: React.ReactNode) => (
                    <a
                        href={AtlassianLink}
                        data-event="clicked"
                        data-event-component="linkButton"
                        data-product-key="jiraServiceManagement"
                        data-label-english="Atlassian.com"
                    >
                        {chunk}
                    </a>
                )
            }
        )
    };

    return (
        <>
            <h2>{messages.header}</h2>
            <p>{messages.body}</p>
        </>
    );
};

export default SessionDurationManagement;
